import React, { useContext, useEffect } from 'react';
import { DateTimePicker } from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Box, Grid, TextField } from '@material-ui/core';
import moment from 'moment';

import { DateTimeContext } from '../../../services/dataTime/dateTime.context';
import { AuthenticationContext } from '../../../services/authentication/authentication.context';

export const DateTime = ({ id, meeting }) => {
  const {
    endDate,
    startDate,
    timeZone,
    commonTime,
    setState,
    setStartDate,
    setEndDate,
    setTimeZone,
    startDateChange,
    endDateChange,
    timeZoneChange,
  } = useContext(DateTimeContext);

  const { userPreferTime } = useContext(AuthenticationContext);
  const timeZonesList = moment.tz.names();

  //========================================================================

  useEffect(() => {
    // local storage
    const LstStartDate = localStorage.getItem('startDate');
    const LstEndDate = localStorage.getItem('endDate');
    const LstTimeZone = localStorage.getItem('timeZone');

    const sDate = LstStartDate
      ? LstStartDate
      : moment(new Date()).format('YYYY-MM-DDTHH:mm');
    const eDate = LstEndDate
      ? LstEndDate
      : moment(new Date()).add(60, 'm').format('YYYY-MM-DDTHH:mm');
    const time_zone = LstTimeZone
      ? LstTimeZone
      : userPreferTime && userPreferTime.user_timezone;

    if (id) {
      meeting && setState(meeting);
    } else {
      setStartDate(sDate);
      setEndDate(eDate);
      setTimeZone(time_zone);
    }
  }, [meeting, id, commonTime, userPreferTime]);

  return (
    <Box my={3}>
      <Grid spacing={1} container>
        <Grid item xs={12} md={4}>
          <DateTimePicker
            minDate={new Date()}
            label='Start time'
            size='small'
            required
            fullWidth
            inputVariant='outlined'
            value={startDate}
            onChange={(e) => startDateChange(e, id)}
            helperText={null}
            error={false}
            animateYearScrolling
            showTodayButton
            format='yyyy/MM/dd HH:mm'
            ampm={false}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <DateTimePicker
            minDate={startDate}
            label='End time'
            size='small'
            required
            fullWidth
            inputVariant='outlined'
            value={endDate}
            onChange={(e) => endDateChange(e, id)}
            helperText={null}
            error={false}
            animateYearScrolling
            showTodayButton
            ampm={false}
            format='yyyy/MM/dd HH:mm'
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Autocomplete
            value={timeZone}
            disableClearable
            onChange={(event, value) => {
              timeZoneChange(value, id);
            }}
            options={timeZonesList}
            size='small'
            renderInput={(params) => (
              <TextField {...params} label='Time zone' variant='outlined' />
            )}
            required
          />
        </Grid>
      </Grid>
    </Box>
  );
};
